import React from 'react';
import variables from '../../../utils/variables';
import './index.css';
import * as PropTypes from 'prop-types';
import logo1 from '../../../assets/roadmap/logo1.svg';
import logo2 from '../../../assets/roadmap/logo2.svg';
import logo3 from '../../../assets/roadmap/logo3.svg';
import logo4 from '../../../assets/roadmap/logo4.svg';
import logo5 from '../../../assets/roadmap/logo5.svg';
import logo6 from '../../../assets/roadmap/logo6.svg';
import background from '../../../assets/roadmap/background.svg';

const Roadmap = (props) => {
    return (
        <section className="roadmap" id="roadmap">
            <div className="heading">
                <h2>{variables[props.lang].roadmap}</h2>
                <span/>
                <p>{variables[props.lang]['roadmap_info']}</p>
            </div>
            <div className="map">
                <div className="info_block">
                    <span/>
                    <div className="info">
                        <div className="image">
                            <img alt={variables[props.lang]['roadmap_heading1']} src={logo1}/>
                        </div>
                        <div className="info_text">
                            <h2>2017</h2>
                            <p className="heading_text">{variables[props.lang]['roadmap_heading1']}</p>
                        </div>
                    </div>
                </div>
                <div className="info_block reverse">
                    <span/>
                    <div className="info">
                        <div className="image">
                            <img alt={variables[props.lang]['roadmap_heading2']} src={logo2}/>
                        </div>
                        <div className="info_text">
                            <h2>2018</h2>
                            <p className="heading_text">{variables[props.lang]['roadmap_heading2']}</p>
                            <p className="sub_text">{variables[props.lang]['roadmap_text2']}</p>
                        </div>
                    </div>
                </div>
                <div className="info_block">
                    <span/>
                    <div className="info">
                        <div className="image">
                            <img alt={variables[props.lang]['roadmap_heading3']} src={logo3}/>
                        </div>
                        <div className="info_text">
                            <h2>2019</h2>
                            <p className="heading_text">{variables[props.lang]['roadmap_heading3']}</p>
                        </div>
                    </div>
                </div>
                <div className="info_block reverse">
                    <span/>
                    <div className="info">
                        <div className="image">
                            <img alt={variables[props.lang]['roadmap_heading4']} src={logo4}/>
                        </div>
                        <div className="info_text">
                            <h2>2020</h2>
                            <p className="heading_text">{variables[props.lang]['roadmap_heading4']}</p>
                            <p className="sub_text">{variables[props.lang]['roadmap_text4']}</p>
                        </div>
                    </div>
                </div>
                <div className="info_block">
                    <span/>
                    <div className="info">
                        <div className="image">
                            <img alt={variables[props.lang]['roadmap_heading5']} src={logo5}/>
                        </div>
                        <div className="info_text">
                            <h2>2021</h2>
                            <p className="heading_text">{variables[props.lang]['roadmap_heading5']}</p>
                        </div>
                    </div>
                </div>
                <div className="info_block reverse">
                    <span/>
                    <div className="info">
                        <div className="image">
                            <img alt={variables[props.lang]['roadmap_heading6']} src={logo6}/>
                        </div>
                        <div className="info_text">
                            <h2>2022</h2>
                            <ul>
                                <li><p className="heading_text">{variables[props.lang]['roadmap_2022_ul_text1']}</p></li>
                                <li><p className="heading_text">{variables[props.lang]['roadmap_2022_ul_text2']}</p></li>
                                <li><p className="heading_text">{variables[props.lang]['roadmap_2022_ul_text3']}</p></li>
                                <li><p className="heading_text">{variables[props.lang]['roadmap_2022_ul_text4']}</p></li>
                            </ul>
                            {/* <p className="heading_text">{variables[props.lang]['roadmap_heading6']}</p> */}
                            {/* <p className="sub_text">{variables[props.lang]['roadmap_text6']}</p> */}
                        </div>
                    </div>
                </div>
                <div className="info_block">
                    <span/>
                    <div className="info">
                        <div className="image">
                            <img alt={variables[props.lang]['roadmap_heading7']} src={logo5}/>
                        </div>
                        <div className="info_text">
                            <h2>2023</h2>
                            <ul>
                                <li><p className="heading_text">{variables[props.lang]['roadmap_ul_text1']}</p></li>
                                <li><p className="heading_text">{variables[props.lang]['roadmap_ul_text2']}</p></li>
                                <li><p className="heading_text">{variables[props.lang]['roadmap_ul_text3']}</p></li>
                                <li><p className="heading_text">{variables[props.lang]['roadmap_ul_text4']}</p></li>
                                <li><p className="heading_text">{variables[props.lang]['roadmap_ul_text5']}</p></li>
                                <li><p className="heading_text">{variables[props.lang]['roadmap_ul_text6']}</p></li>
                                <li><p className="heading_text">{variables[props.lang]['roadmap_ul_text7']}</p></li>
                            </ul>
                            {/* <p className="heading_text">{variables[props.lang]['roadmap_heading7']}</p> */}
                        </div>
                    </div>
                </div>
                <img alt={variables[props.lang].roadmap} src={background}/>
            </div>
            <div className="main_net">
                <h2>2024</h2>
                {/* <p>{variables[props.lang]['launch_main_net']}</p> */}
                <div className="info_block reverse first">
                    <span/>
                    <div className="info">
                        <div className="image">
                            <img alt={variables[props.lang]['roadmap_heading8']} src={logo6}/>
                        </div>
                        <div className="info_text">
                            <h2>2024 <b>Q1</b></h2>
                            <p className="heading_text">{variables[props.lang]['roadmap_2024_q1']}</p>
                            {/* <p className="sub_text">{variables[props.lang]['roadmap_text8']}</p> */}
                        </div>
                    </div>
                </div>
                <div className="info_block">
                    <span/>
                    <div className="info">
                        <div className="image">
                            <img alt={variables[props.lang]['roadmap_heading7']} src={logo5}/>
                        </div>
                        <div className="info_text">
                            <h2>2024 <b>Q2</b></h2>
                            <p className="heading_text">{variables[props.lang]['roadmap_2024_q2']}</p>
                        </div>
                    </div>
                </div>
                <div className="info_block reverse">
                    <span/>
                    <div className="info">
                        <div className="image">
                            <img alt={variables[props.lang]['roadmap_heading8']} src={logo6}/>
                        </div>
                        <div className="info_text">
                            <h2>2024 <b>Q3</b></h2>
                            <p className="heading_text">{variables[props.lang]['roadmap_2024_q3']}</p>
                            {/* <p className="sub_text">{variables[props.lang]['roadmap_text8']}</p> */}
                        </div>
                    </div>
                </div>
                <div className="info_block">
                    <span/>
                    <div className="info">
                        <div className="image">
                            <img alt={variables[props.lang]['roadmap_heading7']} src={logo5}/>
                        </div>
                        <div className="info_text">
                            <h2>2024 <b>Q4</b></h2>
                            <p className="heading_text">{variables[props.lang]['roadmap_2024_q4']}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

Roadmap.propTypes = {
    lang: PropTypes.string.isRequired,
};

export default Roadmap;
